export const dateIndo = (str, useDateTime) => {
  var splitTglWaktu = str.split(" ");
  var tglPiece = splitTglWaktu[0];

  var splitTglPiece = tglPiece.split("-");

  var tgl = splitTglPiece[2];
  var bln = splitTglPiece[1];
  var thn = splitTglPiece[0];

  var ret = tgl + "-" + bln + "-" + thn;

  if (useDateTime) {
    var waktuPiece = splitTglWaktu[1];

    if (waktuPiece !== undefined) {
      ret += " " + waktuPiece;
    }
  }

  return ret;
};

export const convertToRupiah = (angka, showRp) => {
  var rupiah = "";
  var angkarev = angka.toString().split("").reverse().join("");
  for (var i = 0; i < angkarev.length; i++) {
    if (i % 3 === 0) {
      rupiah += angkarev.substr(i, 3) + ".";
    }
  }

  var ret = rupiah
    .split("", rupiah.length - 1)
    .reverse()
    .join("");

  /*
   * Jika showRp bernilai TRUE maka tampilkan string "Rp" di depan angka hasil convert
   */
  if (showRp) {
    ret = "Rp " + ret;
  }

  return ret;
};

export const convertAngkaKeHari = (angka) => {
  switch (parseInt(angka, 10)) {
    case 1:
      return "Senin";
    case 2:
      return "Selasa";
    case 3:
      return "Rabu";
    case 4:
      return "Kamis";
    case 5:
      return "Jumat";
    case 6:
      return "Sabtu";
    default:
      return "Minggu";
  }
};

export const setList = [
  { value: "MASUK", key: "masuk" },
  { value: "PULANG", key: "pulang" },
];



// WEBPACK FOOTER //
// ./src/functions/functionGeneral.js